<template>
  <div id="app">
    <DataView/>
  </div>
</template>
<script>
import DataView from './components/data-view/index.vue'
export default {
  components: {
    DataView
  },
  data () {
    return {}
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}
</style>
